<template>
    <div>
        <ValidationObserver ref="storeForm">
            <b-row>
                <b-col sm="12">
                    <ValidationProvider name="semester_id" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox v-model="form.semester_id" :setActive="true" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12">
                    <b-alert show variant="info" class="py-2">
                        <i class="ri-information-line mr-1 align-middle"></i>
                        {{ $t('makeup_exam_data_help_text') }}
                    </b-alert>
                    <ValidationProvider name="data" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('data')">
                            <b-form-textarea
                                v-model="form.dataRaw"
                                rows="6"
                                :placeholder="$t('makeup_exam_data_placeholder')"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" class="mt-2 text-right">
                    <b-button variant="primary" :disabled="loading" @click="storeExams">
                        <b-spinner small v-if="loading" class="mr-1" />
                        {{ $t('save') }}
                    </b-button>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox.vue"
import MakeUpExamService from "@/services/MakeUpExamService"

export default {
    name: "CreateForm",
    components: {
        ValidationProvider,
        ValidationObserver,
        SemestersSelectbox
    },
    data() {
        return {
            loading: false,
            form: {
                semester_id: null,
                dataRaw: ''
            }
        }
    },
    methods: {
        async storeExams() {
            const isValid = await this.$refs.storeForm.validate()
            if (!isValid) return

            const lines = this.form.dataRaw
                .split('\n')
                .map(s => s.trim())
                .filter(s => s.length > 0)

            if (lines.length === 0) {
                this.$toast.error(this.$t('please_enter_at_least_one_student_number'))
                return
            }

            const payload = {
                semester_id: this.form.semester_id,
                data: lines
            }

            this.loading = true
            MakeUpExamService.store(payload)
                .then(response => {
                    this.loading = false
                    const responseData = response.data?.data || response.data
                    if (responseData && responseData.errors && responseData.errors.length > 0) {
                        this.$emit('error', responseData)
                    } else {
                        this.$toast.success(this.$t('api.' + (response.data.message || 'saved')))
                        this.$emit('success')
                    }
                })
                .catch(err => {
                    this.loading = false
                    if (err.data && err.data.data && err.data.data.errors && err.data.data.errors.length > 0) {
                        this.$emit('error', err.data.data)
                    } else if (err.data && err.data.errors && err.data.errors.length > 0) {
                        this.$emit('error', err.data)
                    } else {
                        this.showErrors(err)
                    }
                })
        }
    }
}
</script>
